// Tile-media lazy loader + play-state detection.
//
// YouTube/Vimeo iframes ship with data-src only; we swap it to src when
// the tile scrolls into view so pages with many tiles don't load every
// embed up front. The iframe also starts with opacity 0 (via CSS) and is
// faded in only once the embed reports it's actually playing — so viewers
// see the poster image during the player's loading/setup phase instead
// of the YouTube or Vimeo branded loading screen.

(function () {
  const iframes = document.querySelectorAll('iframe[data-tile-video][data-src]');
  if (!iframes.length) return;

  // Delay before revealing the iframe after the embed reports PLAYING.
  // YouTube briefly shows its title / play-button overlay for roughly one
  // second after playback starts, then auto-dismisses it. Holding the
  // poster image for a beat longer lets that chrome disappear off-screen.
  const REVEAL_DELAY_MS = {
    youtube: 1200,
    vimeo: 300
  };

  const markPlaying = (iframe) => {
    const tile = iframe.closest('.tile-media');
    if (!tile || tile.classList.contains('tile-media--playing')) return;
    const type = iframe.getAttribute('data-tile-video');
    const delay = REVEAL_DELAY_MS[type] || 0;
    window.setTimeout(() => tile.classList.add('tile-media--playing'), delay);
  };

  const subscribe = (iframe) => {
    const type = iframe.getAttribute('data-tile-video');
    const win = iframe.contentWindow;
    if (!win) return;

    if (type === 'youtube') {
      // YouTube iframe API postMessage protocol (requires enablejsapi=1).
      win.postMessage('{"event":"listening"}', '*');
      win.postMessage(
        JSON.stringify({
          event: 'command',
          func: 'addEventListener',
          args: ['onStateChange']
        }),
        '*'
      );
    } else if (type === 'vimeo') {
      // Vimeo Player API postMessage protocol.
      win.postMessage(JSON.stringify({ method: 'addEventListener', value: 'play' }), '*');
      win.postMessage(JSON.stringify({ method: 'addEventListener', value: 'playing' }), '*');
    }
  };

  const activate = (iframe) => {
    const src = iframe.getAttribute('data-src');
    if (!src) return;
    iframe.addEventListener('load', () => subscribe(iframe), { once: true });
    iframe.setAttribute('src', src);
    iframe.removeAttribute('data-src');
  };

  // Global listener for messages from any tile iframe.
  window.addEventListener('message', (event) => {
    let data = event.data;
    if (typeof data === 'string') {
      try {
        data = JSON.parse(data);
      } catch (e) {
        return;
      }
    }
    if (!data || typeof data !== 'object') return;

    // YouTube: { event: "onStateChange", info: 1 } where 1 = PLAYING.
    if (data.event === 'onStateChange' && data.info === 1) {
      iframes.forEach((iframe) => {
        if (iframe.contentWindow === event.source) markPlaying(iframe);
      });
      return;
    }

    // Vimeo: { event: "play" } or { event: "playing" }.
    if (data.event === 'play' || data.event === 'playing') {
      iframes.forEach((iframe) => {
        if (iframe.contentWindow === event.source) markPlaying(iframe);
      });
    }
  });

  if (!('IntersectionObserver' in window)) {
    iframes.forEach(activate);
    return;
  }

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          activate(entry.target);
          observer.unobserve(entry.target);
        }
      });
    },
    { rootMargin: '200px 0px' }
  );

  iframes.forEach((iframe) => observer.observe(iframe));
})();
